<template>
  <div>
    <cover :pageData="pageData"></cover>
    <div class="page">
      <div
        class="title"
        v-for="item in categoryList"
        :key="item.id"
        v-show="tabIndex == item.id"
      >
        <div class="cn_title">{{ item.name }}</div>
        <div class="en_title">{{ item.englishName }}</div>
      </div>
      <div class="content">
        <div class="content_left">
          <div class="options_title">按业务分类</div>
          <div class="options">
            <div
              class="base_front"
              v-for="item in categoryList"
              :key="item.id"
              :class="tabIndex == item.id ? 'blue' : 'gray'"
              @click="chooseOption(item.id, item.name)"
            >
              {{ item.name }}
              <div class="option_img" v-show="tabIndex != item.id">
                <img src=../assets/img/24x24_product_right_un@2x.png>
              </div>
              <div class="option_img" v-show="tabIndex == item.id">
                <img src=../assets/img/24x24_product_right@2x.png>
              </div>
            </div>
          </div>
        </div>
        <div class="content_right">
          <div v-html="markets.details" v-show="!showServices"></div>
          <div v-show="showServices">
            <div
              class="new"
              v-for="item in newsList"
              :key="item.id"
              @click="toNews(item.id)"
            >
              <div class="news_left">
                <img :src="img_api + item.image" alt="" />
              </div>
              <div class="news_right">
                <div class="news_title">{{ item.name }}</div>
                <div class="news_des">{{ item.brief }}</div>
                <div class="news_time">{{ item.time }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		<div class="pag" v-show="showServices">
			<el-pagination :current-page="currentPage" :page-size="pageSize" :total="total"
				@current-change="handleCurrentChange" background layout="prev, pager, next">
			</el-pagination>
		</div>
  </div>
</template>

<script>
import cover from "../components/cover.vue";
import { getNews,getMarketPage, getServeDetails } from "@/server/https.js";
export default {
  name: "",
  components: {
    cover,
  },
  data() {
    return {
      img_api: 'https://www.gdyuanwo.com/gdyuanwo/',
      currentPage: 1, // 当前页码默认值为1
			pageSize: 4, // 每页显示条数默认值为10
			total: 0, // 数据总数
      dialogTableVisible: false,
      showServices: false,
      img: "",
      tabIndex: "",
      newsList:[],
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      markets: {},
      diagData: {},
      categoryList: [],
      serviceList: [
        {
          id: 1,
          title: "售后服务政策",
          des: "快速查看广东远沃售后服务条款",
          img: require("../assets/img/50x50_shouhou@2x.png"),
        },
        {
          id: 2,
          title: "用户协议证书",
          des: "快速查看广东远沃用户协议政策",
          img: require("../assets/img/50x50_yonghuxieyi@2x.png"),
        },
        {
          id: 3,
          title: "隐私协议政策",
          des: "快速查看广东远沃隐私协议政策",
          img: require("../assets/img/50x50_yinsixieyi@2x.png"),
        },
        {
          id: 4,
          title: "在线询价",
          des: "联系客服获取最新报价",
          img: require("../assets/img/50x50_zaixianxunjia@2x.png"),
        },
      ],
    };
  },
  mounted() {
    getMarketPage().then((res) => {
      res.data.body.categoryList.sort((a, b) => a.sort - b.sort);
      this.categoryList = res.data.body.categoryList;
      // this.markets = res.data.body.page;
      this.chooseOption(res.data.body.categoryList[0].id);
    });

    getServeDetails().then((res) => {
      this.diagData = res.data.body.data;
    });

    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 4) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
  },
  methods: {
    //发请求获取tradeList数据
    chooseOption(index, name) {
      this.currentPage = 1;
      this.tabIndex = index;
      if (name == "服务支持") {
        this.showServices = true;
        this.getTypeNews()
      } else {
        this.showServices = false;
        getMarketPage({ categoryId: index }).then((res) => {
          this.markets = res.data.body.page.list[0];
        });
      }
    },
    getTypeNews(){
			getNews({ pageNo: this.currentPage, pageSize: this.pageSize, type:3 }).then(res => {
					res.data.body.page.list.sort((a, b) => a.sort - b.sort);
					this.newsList = res.data.body.page.list;
					this.total = res.data.body.page.count;
				})
		},
    toNews(e) {
			this.$router.push({
				name: "NewsDetail",
				query: {
					newsId: e,
				}
			});
		},
    handleCurrentChange(currentPage) {
			this.currentPage = currentPage;
				this.getTypeNews()
		},
  },
};
</script>

<style scoped>
.page {
  /* display: flex; */
  /* justify-content: center; */
  position: relative;
  width: 1200px;
  margin: auto;
}

.content {
  display: flex;
  margin-top: 180px;
}

.content_left {
  overflow: hidden;
  width: 230px;
  margin-bottom: 20px;
  margin-right: 2rem;
}

.content_right {
  width: 900px;
  margin-left: 20px;
}

.title {
  display: flex;
  justify-content: center;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  margin-top: 56px;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
  margin-top: 56px;
}

.options {
  position: relative;
  background-color: #f7f8fa;
}

.options_title {
  width: 100%;
  padding: 10px;
  text-align: start;
  padding-left: 20px;
  line-height: 50px;
  background-color: #13489d;
  font-size: 22px;
  font-weight: bold;
  color: #ffffff;
}

.base_front {
  display: flex;
  padding-left: 20px;
  font-size: 18px;
  font-weight: 500;
  padding: 20px 0 20px 20px;
  border-bottom: 2px dashed #f7f8fa;
}

.gray {
  color: #333333;
}

.blue {
  color: #13489d;
}

.base_front:hover {
  cursor: pointer;
}

.option_img {
  position: absolute;
  right: 30px;
  width: 20px;
  height: 20px;
}

.option_img img {
  width: 100%;
  height: 100%;
}

.front {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  text-indent: 25px;
  line-height: 2;
  /* margin-top: 30px; */
  margin-bottom: 30px;
}

.img_box {
  margin-bottom: 30px;
}

.content_img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pag {
  float: right;
  margin-bottom: 40px;
  margin-right: 200px;
}

.services {
  display: flex;
}

.service {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 276px;
  height: 284px;
  background: #f5f5f5;
  margin-right: 20px;
}

.service_img_box {
  margin-top: 40px;
  width: 48px;
  height: 48px;
}

.service_img_box img {
  width: 100%;
  height: 100%;
}

.service_title {
  margin-top: 20px;
  font-size: 25px;
  font-weight: bold;
  color: #333333;
}

.service_des {
  margin-top: 20px;
  font-size: 15px;
  width: 150px;
  text-align: center;
  font-weight: 500;
  color: #666666;
}

.goto {
  margin-top: 20px;
  font-size: 15px;
  font-weight: 400;
  color: #13489d;
}

.goto:hover {
  cursor: pointer;
}
/* 新闻 */
.new {
	display: flex;
	padding: 20px;
	border-bottom: 1px solid #999999;
	cursor: pointer;
}

.news_left {
	width: 354px;
	height: 204px;
}

.news_left img {
	width: 100%;
	height: 100%;
}

.news_title {
	font-size: 16px;
	font-weight: 500;
	color: #333333;
}

.news_des {
	margin-top: 16px;
	font-size: 14px;
	font-weight: 400;
	color: #999999;
}

.news_time {
	margin-top: 16px;
	font-size: 14px;
	font-weight: 400;
	color: #999999;
}
.news_right {
	width: 600px;
	margin-left: 20px;
}
</style>
